import Constants from "./constants";
// types
import type { ReadonlyDeep } from "type-fest";
import type { GatewayId } from "../types/gateway";
import type {
	DeviceId, DeviceName, PowerLevelStatus, ReachableStatus,
	StoredDevice, DeviceObj, DeviceData, Attributes,
} from "../types/device";
import type { RocId } from "../types/roc-table";

class Device {

	protected _invalid: boolean;
	protected readonly _gatewayId: GatewayId;
	protected _device: DeviceData;

	constructor(gatewayId: GatewayId, device: ReadonlyDeep<DeviceData>) {
		this._invalid = gatewayId === "" || device.id === "";
		this._gatewayId = gatewayId;
		this._device = device as DeviceData;
	}

	public toStorage(): StoredDevice {
		return [this._gatewayId, this._device] as const;
	}

	public clone(): DeviceObj {
		return new Device(this._gatewayId, this._device);
	}

	public get invalid(): boolean {
		return this._invalid;
	}

	public get gwId(): GatewayId {
		return this._gatewayId;
	}

	public get deviceData(): ReadonlyDeep<DeviceData> {
		return this._device;
	}

	public get srcGw(): GatewayId {
		return this._device.srcGw;
	}

	public get id(): DeviceId {
		return this._device.id;
	}

	public get name(): DeviceName {
		return this._device.name ?? this._device.id;
	}

	public get rocId(): RocId {
		return this._device.rocId;
	}

	public get reachableStatus(): ReachableStatus {
		return this._device[Constants.Device.Property.ReachableStatus] ?? this._device.status;
	}

	public get batteryStatus(): PowerLevelStatus | undefined {
		return this._device[Constants.Device.Property.PowerLevelStatus] ?? this._device.power;
	}

	public getAttribute<ATTR extends keyof Attributes = keyof Attributes>(attributeProp: ATTR): Attributes[ATTR] {
		return this._device.attributes[attributeProp];
	}

}

export default Device;
